import { Box, styled } from '@mui/material';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

export const Sheet = styled(SwipeableDrawer)`
  .MuiDrawer-paper {
    max-height: 90vh;
    border-radius: 10px 10px 0px 0px;
  }
`;

export const SheetContent = styled(Box)``;

export const SheetHeaderWrapper = styled(Box)`
  width: 100%;
  min-height: 24px;
  height: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SheetDragIndicator = styled(Box)`
  width: 18px;
  height: 4px;
  border-radius: 99px;
  background-color: rgb(196, 196, 198);
`;

export const SheetDragIndicatorLeft = styled(SheetDragIndicator, {
  shouldForwardProp: (prop) => prop !== 'isDragged',
})<{
  isDragged: boolean;
}>`
  transform: ${(props) =>
    props.isDragged ? `translateX(2px) rotate(10deg)` : `translateX(2px) rotate(0deg)`};
`;

export const SheetDragIndicatorRight = styled(SheetDragIndicator, {
  shouldForwardProp: (prop) => prop !== 'isDragged',
})<{
  isDragged: boolean;
}>`
  transform: ${(props) =>
    props.isDragged ? `translateX(-2px) rotate(-10deg)` : `translateX(-2px) rotate(0deg)`};
`;
